import { useRef, useEffect } from "react";

function VideoComponent({ url }) {
  const videoRef = useRef();
  const previousUrl = useRef(url);

  useEffect(() => {
    if (previousUrl.current === url) {
      return;
    }

    if (videoRef.current) {
      videoRef.current.load();
    }

    previousUrl.current = url;
  }, [url]);

  return (
    <video height="400" controls ref={videoRef} autoPlay className="videoThumbnail">
      <source src={url} />
    </video>
  );
}

export default VideoComponent;
